// ═══════════════════════════════════════════════════════════════════════════
// PIANI NEXIORA — FONTE UNICA (listino Rev3, 30/10/2026)
// ═══════════════════════════════════════════════════════════════════════════
// Contatti e indirizzi (email commerciale, sito, pagina prezzi) NON stanno qui: vengono
// dalla configurazione del fornitore (utils/fornitore.js).
// Tutto ciò che riguarda prezzi, piani, periodo di prova e moduli inclusi DEVE
// leggere da questo file: app, pannello Platform Owner e testi. Gli stessi numeri
// sono sulla pagina Prezzi del sito vetrina e nel foglio
// Nexiora_Pricing_29set2026_rev1.xlsx: se cambi qui, cambia anche lì, altrimenti
// si creano contestazioni.
//
// Regole commerciali:
//  • Rev2 (06/10/2026, decisione di Paolo): NESSUN piano gratuito. Dopo la prova serve il
//    Pro o il Gold; si paga sempre almeno un blocco da 5 posti (Rev3: Pro €49, Gold €65 al
//    mese), anche con 1–3 utenti. Senza piano: tutta l'organizzazione in sola lettura, dati
//    consultabili ed esportabili, mai cancellati.
//  • I moduli "free" della tabella sono quelli di BASE, inclusi in ogni piano.
//  • Posti a blocchi di 5; scaglioni progressivi (primi 5 posti al 1° prezzo, dal 6°
//    al 10° al 2°, dall'11° in poi al 3°). Ogni scaglione ha il suo prezzo Pro e Gold.
//  • Rev3 (30/10/2026, decisione di Paolo dopo il confronto con i concorrenti): il primo
//    blocco da 5 posti costa €49 (Gold €65) al mese, così il cliente piccolo copre il costo di
//    avvio e assistenza; i posti successivi restano bassi (€6 e €5, Gold €8 e €7) perché
//    l'azienda da 10–20 persone faccia entrare tutti. Prima: €6,50/€5,50/€5 + €2 Gold.
//  • Prova: 90 giorni con TUTTI i moduli, Gold compreso. Dopo: dati mai cancellati.
//  • Un piano pagato vale solo con organizations.status === "active" (lo imposta il
//    Platform Owner finché non c'è il pagamento online).
// ═══════════════════════════════════════════════════════════════════════════

export const LISTINO = {
  versione: "Rev3 — 30/10/2026",
  freeMaxUtenti: 0,                // Rev2: nessun piano gratuito
  bloccoPosti: 5,
  scaglioni: [                     // prezzo per posto al mese, IVA esclusa
    { finoAPosto: 5,        prezzo: 9.8, prezzoGold: 13 },   // primo blocco: Pro €49, Gold €65
    { finoAPosto: 10,       prezzo: 6.0, prezzoGold: 8 },
    { finoAPosto: Infinity, prezzo: 5.0, prezzoGold: 7 },
  ],
  scontoAnnuale: 0.10,             // pagamento annuale: mensile × 12 × (1 − sconto)
  giorniProva: 90,
};

// FORMAZIONE (24/10/2026, decisa con Paolo) — servizio accessorio, separato dall'abbonamento,
// su prenotazione e secondo disponibilità; si paga solo dopo la conferma della data.
// Stessi numeri nel sito (vetrina/formazione.html, prezzi.html), nelle condizioni di servizio
// e nella risposta di Nexi (utils/assistenteGuida.js): la prova demo/prove/prova_formazione.mjs
// controlla che coincidano. IVA esclusa.
export const FORMAZIONE = {
  avvioGratuitoMinuti: 45,          // in video call, una volta per azienda
  avvioEntroGiorniProva: 30,        // da chiedere entro i primi 30 giorni di prova
  videocall: { ore: 3, prezzo: 450 },
  presenza: { ore: 3, prezzo: 600 },
  oraSingola: 200,                  // in video call, senza pacchetto
  oraAggiuntiva: 90,                // solo insieme a un pacchetto
  mesiOreAggiuntive: 6,
  maxPartecipanti: 6,
  euroKm: 0.70,                     // andata e ritorno
  kmViaggioIncluso: 50,
  euroOraViaggio: 45,               // oltre i km inclusi
  kmVittoAlloggio: 300,             // oltre: vitto e alloggio al costo
  oreSpostamentoGratuito: 48,
  giorniRisposta: 3,                // lavorativi
  giorniPagamentoAnticipato: 7,     // W430: bonifico entro 7 giorni prima dell'incontro
  ivaPerc: 22,
  validitaOffertaGiorni: 30,
};

export const PIANI_INFO = {
  free: { id: "free", label: "Base", colore: "#6b7280", bg: "#f3f4f6", emoji: "📦" }, // moduli di base, in ogni piano
  pro:  { id: "pro",  label: "Pro",  colore: "#7c3aed", bg: "#ede9fe", emoji: "⚡" },
  gold: { id: "gold", label: "Gold", colore: "#d97706", bg: "#fef3c7", emoji: "⭐" },
};
const ORDINE = { free: 0, pro: 1, gold: 2 };

// Moduli e piano minimo che li include (stessa tabella del foglio "Moduli per piano").
export const MODULI = {
  commesse:     { label: "Clienti, commesse e attività",                  piano: "free" },
  documenti:    { label: "Sopralluoghi, rapportini, DDT, corrispondenza, giornale di cantiere", piano: "free" },
  base:         { label: "Scadenzario, notifiche, chat, strumenti tecnici, esportazione", piano: "free" },
  offerte:      { label: "Offerte, segnalazioni, relazioni",              piano: "pro" },
  manutenzione: { label: "Manutenzione",                                  piano: "pro" },
  acquisti:     { label: "Acquisti e magazzino",                          piano: "pro" },
  squadra:      { label: "Presenze, ferie e pianificazione della squadra", piano: "pro" },
  economico:    { label: "Economico di commessa, note spese, computo/SAL", piano: "pro" },
  insight:      { label: "Nexiora Insight",                               piano: "gold" },
  report:       { label: "Report Commessa automatico",                    piano: "gold" },
  direzione:    { label: "Cabina di Regia e Controlli PM",                piano: "gold" },
  whatsapp:     { label: "Promemoria WhatsApp",                           piano: "gold" },
  subappaltatori: { label: "Documenti dei subappaltatori",               piano: "gold" },
  ditte:        { label: "Ditte esterne: anagrafica e lavoro affidato",   piano: "pro" },
  pratiche:     { label: "Pratiche e documenti dal cliente",              piano: "pro" },
  sicurezza:    { label: "Sicurezza di cantiere",                         piano: "pro" },
};

// Pagina dell'app → modulo del listino. Le pagine non elencate sono Free (o di servizio).
// Serve per il banner "sola lettura" e per il lucchetto nella barra laterale; il blocco
// vero delle scritture è nelle Regole Firestore (livelloCollezione), con la stessa tabella.
export const PAGINA_MODULO = {
  "elaborazione-offerte": "offerte", "registro-richieste-comm": "offerte", "nuova-richiesta-potenziale": "offerte",
  "segnalazioni-cliente": "offerte", "registro-segnalazioni": "offerte", "verbali": "offerte",
  "impianti": "manutenzione", "contratti-manutenzione": "manutenzione", "gestione-contratti-manutenzione": "manutenzione",
  "registro-interventi": "manutenzione",
  "centro-acquisti": "acquisti", "magazzino": "acquisti", "ordini-materiali": "acquisti", "richiedi-nf": "acquisti",
  "rientro-materiali": "acquisti", "registro-noleggi": "acquisti", "registro-rientri-materiali": "acquisti",
  "listino-materiali": "acquisti", "parco-mezzi": "acquisti", "disponibilita-mezzi": "acquisti",
  "presenze": "squadra", "approvazione-cartellini": "squadra", "richiesta-ferie": "squadra",
  "approvazione-ferie-permessi": "squadra", "programmazione": "squadra", "pianificazione-team": "squadra",
  "dipendenti": "squadra", "report-ore": "squadra",
  "nota-spese": "economico", "approvazione-note-spese": "economico", "registro-sal": "economico",
  "da-fatturare": "economico", "registro-cavi": "economico", "control-center": "economico",
  "nexiora-insight": "insight",
  "documenti-subappaltatori": "subappaltatori",
  "ditte-esterne": "ditte",
  "pratiche-aperte": "pratiche",
};

/** "full" = si usa normalmente; "readonly" = consultabile ma non modificabile. */
export function statoModulo(modulo, stato) {
  if (!stato) return "full";
  if (stato.bloccoTotale) return "readonly";
  return moduloIncluso(modulo, stato.pianoEffettivo) ? "full" : "readonly";
}

/** Piano "commerciale" normalizzato: i vecchi valori (enterprise, business…) valgono Gold. */
export function normalizzaPiano(p) {
  if (p === "pro" || p === "gold" || p === "free") return p;
  if (p === "enterprise" || p === "business") return "gold";
  return "free";
}

// ─── Calcoli di prezzo ────────────────────────────────────────────────────
export function postiDaPagare(utenti) {
  const b = LISTINO.bloccoPosti;
  return Math.max(b, Math.ceil(Math.max(0, utenti || 0) / b) * b);
}

/** Canone mensile (IVA esclusa) per un numero di POSTI già arrotondato al blocco. */
export function canoneMensile(posti, piano = "pro") {
  let tot = 0, prec = 0;
  for (const s of LISTINO.scaglioni) {
    const n = Math.max(0, Math.min(posti, s.finoAPosto) - prec);
    tot += n * (normalizzaPiano(piano) === "gold" ? s.prezzoGold : s.prezzo);
    prec = s.finoAPosto;
    if (posti <= s.finoAPosto) break;
  }
  if (normalizzaPiano(piano) === "free") return 0;
  return Math.round(tot * 100) / 100;
}

export function canoneAnnuale(posti, piano = "pro") {
  return Math.round(canoneMensile(posti, piano) * 12 * (1 - LISTINO.scontoAnnuale) * 100) / 100;
}

/** Preventivo completo per N utenti attivi. */
export function preventivo(utenti, piano = "pro") {
  const posti = postiDaPagare(utenti);
  return { utenti, posti, mensile: canoneMensile(posti, piano), annuale: canoneAnnuale(posti, piano) };
}

export const euro = (n) =>
  "€" + Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// ─── Stato dell'organizzazione ────────────────────────────────────────────
const aData = (v) => (v?.toDate ? v.toDate() : v ? new Date(v) : null);

/**
 * Stato del piano di un'organizzazione.
 *  pianoPagato    — "pro"/"gold" se attivato dal Platform Owner (status "active"), altrimenti null
 *  inProva        — prova ancora in corso (tutti i moduli)
 *  provaScaduta   — prova finita e nessun piano pagato
 *  pianoEffettivo — "trial" | "free" | "pro" | "gold"
 *  bloccoTotale   — prova finita e nessun piano pagato: tutta l'organizzazione in sola
 *                   lettura finché il titolare non attiva un piano (dati sempre esportabili)
 */
export function statoPiano(org, { isPlatformOwner = false, now = new Date() } = {}) {
  const utentiAttivi = org?.seatsUsed || 0;
  const piano = normalizzaPiano(org?.plan);
  const pianoPagato = (piano !== "free" && org?.status === "active") ? piano : null;
  const fine = aData(org?.trialEndsAt);
  // Senza data di fine prova (organizzazioni storiche) vale come prova in corso: stesso
  // comportamento delle Regole Firestore e delle Cloud Functions, nessuna si blocca da sola.
  const inProva = !pianoPagato && (!fine || fine > now);
  const provaScaduta = !pianoPagato && !!fine && fine <= now;
  const giorniProva = fine ? Math.max(0, Math.ceil((fine - now) / 86400000)) : null;
  let pianoEffettivo = pianoPagato || (inProva ? "trial" : "free");
  if (isPlatformOwner) pianoEffettivo = "gold";
  // Rev2: senza piano pagato, a prova finita tutta l'organizzazione è in sola lettura
  const bloccoTotale = !isPlatformOwner && provaScaduta;
  return { piano, pianoPagato, inProva, provaScaduta, giorniProva, pianoEffettivo, utentiAttivi, bloccoTotale,
           postiAcquistati: org?.seats || 0 };
}

/** Il piano effettivo include il modulo? La prova include tutto. */
export function moduloIncluso(modulo, pianoEffettivo) {
  if (pianoEffettivo === "trial") return true;
  const richiesto = MODULI[modulo]?.piano || "free";
  return (ORDINE[pianoEffettivo] ?? 0) >= ORDINE[richiesto];
}

/** Etichetta del piano che serve per un modulo ("Pro" o "Gold"). */
export const pianoRichiestoLabel = (modulo) => PIANI_INFO[MODULI[modulo]?.piano || "free"].label;

/** Testo dell'avviso quando si abilita un utente (null se non serve avvisare). */
export function avvisoNuovoUtente(stato, nuoviAttivi) {
  const p = preventivo(nuoviAttivi, stato.pianoPagato || "pro");
  if (stato.pianoPagato) {
    if (stato.postiAcquistati && nuoviAttivi > stato.postiAcquistati) {
      return `Con ${nuoviAttivi} utenti superi i ${stato.postiAcquistati} posti del tuo piano ${PIANI_INFO[stato.pianoPagato].label}. ` +
        `Servono ${p.posti} posti: ${euro(p.mensile)}/mese IVA esclusa. Il nuovo blocco si paga in proporzione ai giorni residui del periodo.`;
    }
    return null;
  }
  // In prova: si avvisa solo quando il nuovo utente fa scattare un blocco di posti in più
  if (stato.inProva && p.posti > postiDaPagare(nuoviAttivi - 1)) {
    return `Con ${nuoviAttivi} utenti, alla fine della prova il piano Pro costerà ${euro(p.mensile)}/mese IVA esclusa (${p.posti} posti; ${euro(p.annuale)}/anno con pagamento annuale). Durante la prova non paghi nulla.`;
  }
  return null;
}
